<template>
  <v-container fluid class="pa-0 mt-10" style="min-height: 500px;">
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-col cols="11" class="mx-auto pa-2 mb-4">
          <h1 v-if="category" class="mb-8">
            Notícias - {{ category.title }}
          </h1>
          <h1 v-else class="mb-8">
            Notícias
          </h1>

          <div
            v-if="paginatedPrivacyNews.length === 0"
            class="my-8 text-center"
          >
            <h2>Nenhuma notícia encontrada.</h2>
          </div>

          <v-row v-else>
            <v-col
              v-for="news in paginatedPrivacyNews"
              :key="news.id"
              cols="12"
              lg="3"
              sm="6"
            >
              <v-card
                hover
                height="500"
                elevation="10"
                class="mx-auto d-flex flex-column justify-space-between"
                color="white lighten-5"
                style="
                  border-radius: 15px;
                  transition: transform 0.3s;
                  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                "
              >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  :src="news.featuredImage"
                  style="
                    border-top-left-radius: 15px;
                    border-top-right-radius: 15px;
                  "
                />
                <v-card-subtitle
                  class="text-uppercase pt-5 px-6 pb-0"
                  style="color: #616161"
                >
                  {{ news.createdAt | dateFormatted }}
                </v-card-subtitle>
                <v-card-text class="py-0 px-2 text-card">
                  <v-card-title
                    class="text-truncate truncate-1"
                    style="font-weight: 600"
                  >
                    {{ news.headline }}
                  </v-card-title>
                  <v-card-subtitle class="text-truncate" style="color: #757575">
                    {{ news.caption }}
                  </v-card-subtitle>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    outlined
                    color="secondary"
                    :to="`${
                      redirectToExternalPage() ? '/external' : ''
                    }/read-privacy-news/${news.slug}`"
                    style="border-radius: 20px; padding: 5px 20px; margin: 10px"
                  >
                    Ver mais
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-col>

      <v-col v-if="lgpds.length > 0" cols="12" class="text-center mb-6">
        <v-pagination
          v-model="currentPage"
          :length="pageCount"
          color="#173c93"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PrivacyPortalCategory from "../../services/privacy-portal-category";

export default {
  name: "PrivacyPortalCategory",
  data() {
    return {
      lgpds: [],
      category: undefined,
      currentPage: 1,
      itemsPerPage: 4,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.lgpds.length / this.itemsPerPage);
    },
    paginatedPrivacyNews() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.lgpds.slice(start, end);
    },
  },
  async created() {
    const id = this.$route.params.id;
    this.category = await PrivacyPortalCategory.findPrivacyCategoryById(id);
    if (this.category) {
      this.lgpds = this.category.lgpd;
    }
  },
  methods: {
    redirectToExternalPage() {
      return this.$route.name && this.$route.name.startsWith("external");
    },
  },
};
</script>

<style scoped>
.border-blue {
  border: 1px solid #173c94;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: #173c94;
}

.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #173c94;
  margin-bottom: 0.5rem;
}

.main-text {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
  margin-bottom: 1.2rem;
}

.truncate-1 {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
